import { render, staticRenderFns } from "./OfficeInfoAiRouteEditor.vue?vue&type=template&id=4c40c3a5&"
import script from "./OfficeInfoAiRouteEditor.vue?vue&type=script&lang=ts&"
export * from "./OfficeInfoAiRouteEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRow,VSimpleTable,VSwitch,VTooltip})
